import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import translation files (flat structure from Tolgee)
import enTranslations from '../locales/en.json'
import esTranslations from '../locales/es-ES.json'
import ukTranslations from '../locales/uk-UA.json'
import deTranslations from '../locales/de.json'
import nbTranslations from '../locales/nb.json'
// Note: Russian is commented out but keeping import for future use
// import ruTranslations from '../locales/ru.json'

// Define available languages
export const AVAILABLE_LANGUAGES = [
  { code: 'en', name: 'English', nativeName: 'English' },
  //{ code: 'ru', name: 'Russian', nativeName: 'Русский' },
  { code: 'es', name: 'Spanish', nativeName: 'Español' },
  { code: 'uk', name: 'Ukrainian', nativeName: 'Українська' },
  { code: 'de', name: 'German', nativeName: 'Deutsch' },
  { code: 'nb', name: 'Norwegian', nativeName: 'Norsk' }
] as const

export type LanguageCode = typeof AVAILABLE_LANGUAGES[number]['code']

// Configure i18next
i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    debug: false,
    fallbackLng: {
      'ru': ['uk', 'en'],  // Russian users get Ukrainian first, then English
      'default': ['en']
    },
    supportedLngs: AVAILABLE_LANGUAGES.map(lang => lang.code),
    
    // Resources (flat structure - all namespaces in one file)
    // Load entire flat structure into 'common' namespace so t('app.name') resolves as common.app.name
    resources: {
      en: {
        common: enTranslations  // Contains all namespaces: common, app, navigation, etc.
      },
      es: {
        common: esTranslations
      },
      uk: {
        common: ukTranslations
      },
      de: {
        common: deTranslations
      },
      nb: {
        common: nbTranslations
      }
    },
    
    // Default namespace
    defaultNS: 'common',
    // Components use useTranslation('common') and can access all namespaces via t('app.name'), t('navigation.home'), etc.
    
    // Language detection options
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },
    
    interpolation: {
      escapeValue: false // React already escapes values
    },
    
    react: {
      useSuspense: true
    }
  })

// Update HTML lang attribute on language change
i18n.on('languageChanged', (lng: string) => {
  document.documentElement.lang = lng
})

// Set initial HTML lang attribute
if (i18n.language) {
  document.documentElement.lang = i18n.language
}

export default i18n

